var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { WidgetHeader, WidgetTitle } from "../";
import { ModuleAvatar, ModuleHeader, ModuleTitle, ModuleDescription } from "../";
import { getThemeStyle } from "../../resources/functions/";
import { getOwnerIcon } from "../../resources/icons/";

var OwnerWidgetHeader = (_temp2 = _class = function (_Component) {
    _inherits(OwnerWidgetHeader, _Component);

    function OwnerWidgetHeader() {
        var _temp, _this, _ret;

        _classCallCheck(this, OwnerWidgetHeader);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getHeaderStyle = function () {
            var imageUrl = _this.props.imageUrl;


            var style = {};

            if (imageUrl) {
                style = {
                    backgroundImage: "url(" + imageUrl + ")"
                };
            }

            return style;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    OwnerWidgetHeader.prototype.render = function render() {
        var _props = this.props,
            title = _props.title,
            abbr = _props.abbr,
            theme = _props.theme;


        var headerStyle = this.getHeaderStyle();
        var avatarStyle = getThemeStyle(theme);

        //        const icon = getOwnerIcon({text: abbr.toUpperCase(), fill: theme && theme.primaryColor })

        return React.createElement(
            WidgetHeader,
            { style: headerStyle },
            React.createElement(ModuleAvatar, { abbr: abbr, style: avatarStyle }),
            React.createElement(WidgetTitle, { title: title || "Title" })
        );
    };

    return OwnerWidgetHeader;
}(Component), _class.defaultProps = {
    imageUrl: undefined,
    theme: {
        primaryColor: "#ccc"
    }
}, _temp2);


export default OwnerWidgetHeader;